import { marker } from '@colsen1991/ngx-translate-extract-marker';


const BUTTON_LABELS_TRANSLATIONS: string[] = [
    marker('global.labels.participants'),
    marker('global.actions.addVersion'),
    marker('global.actions.addStop'),
    marker('global.actions.addIds'),
]

export enum BtnLabels {
    BackLink = 'ui.back-link.text',
    StopsHead = 'global.actions.addStop',
    RoutesHead = 'modules.routes.blank',
    TariffVersionsHead = 'global.actions.addVersion',
    Add = 'global.actions.add',
    Create = 'global.actions.create',
    AddIds = 'global.actions.addIds',
    DownloadParticipants = 'global.labels.participants',
    SearchHead = 'modules.search.head',
    Refresh = 'global.actions.refresh',
    Export = 'global.labels.export',
}
